import { FC } from 'react';
import { ConfigField, ConfigSlideId } from '@/eventConfig/types.ts';
import { TextInput } from '@/form/fields/TextInput/TextInput.tsx';
import { RichtextInput } from '@/form/fields/RichtextInput/RichtextInput.tsx';
import { CollapsibleInput } from '@/form/fields/CollapsibleInput/CollapsibleInput.tsx';
import { PhoneNumberInput } from '@/form/fields/PhoneNumberInput/PhoneNumberInput.tsx';
import { NumberInput } from '@/form/fields/NumberInput/NumberInput.tsx';
import { SelectInput } from '@/form/fields/SelectInput/SelectInput.tsx';
import { CheckboxInput } from '@/form/fields/CheckboxInput/CheckboxInput.tsx';
import { SwitchInput } from '@/form/fields/SwitchInput/SwitchInput.tsx';
import { useForm } from '@/form/useForm.ts';
import { ButtonsInput } from '@/form/fields/ButtonsInput/ButtonsInput.tsx';
import { BmiDisplay } from './BmiDisplay/BmiDisplay';
import { EmailInput } from '@/form/fields/EmailInput/EmailInput.tsx';
import { AddressFinder } from '@/form/fields/AddressFinder/AddressFinder.tsx';
import { FilterSelectInput } from '@/form/fields/FilterSelectInput/FilterSelectInput.tsx';

interface RenderFieldProps {
  slideId: ConfigSlideId;
  field: ConfigField;
}

export const RenderField: FC<RenderFieldProps> = ({ slideId, field }) => {
  const { getFieldStatus, onChange, getFieldValue } = useForm();

  const fieldProps = {
    field,
    slideId,
    onChange,
    getFieldStatus,
    getFieldValue,
  };

  if (field.type === 'text') {
    return <TextInput {...fieldProps} />;
  }

  if (field.type === 'email') {
    return <EmailInput {...fieldProps} />;
  }

  if (field.type === 'buttons') {
    return <ButtonsInput {...fieldProps} />;
  }

  if (field.type === 'richtext') {
    return <RichtextInput {...fieldProps} />;
  }

  if (field.type === 'collapsible') {
    return <CollapsibleInput {...fieldProps} />;
  }

  if (field.type === 'phone') {
    return <PhoneNumberInput {...fieldProps} />;
  }

  if (field.type === 'number') {
    return <NumberInput {...fieldProps} />;
  }

  if (field.type === 'select') {
    return <SelectInput {...fieldProps} />;
  }

  if (field.type === 'filter_select') {
    return <FilterSelectInput {...fieldProps} />;
  }

  if (field.type === 'checkbox') {
    return <CheckboxInput {...fieldProps} />;
  }

  if (field.type === 'switch') {
    return <SwitchInput {...fieldProps} />;
  }

  if (field.type === 'bmidisplay') {
    return <BmiDisplay {...fieldProps} />;
  }

  if (field.type === 'address_finder') {
    return <AddressFinder {...fieldProps} />;
  }

  console.log('Field type not supported: ', field.type);
  return null;
};
